export enum InvoicesDashboardTypes {
  FETCH_USERS_WITH_INVOICES_START = 'FETCH_USERS_WITH_INVOICES_START',
  FETCH_USERS_WITH_INVOICES_SUCCESS = 'FETCH_USERS_WITH_INVOICES_SUCCESS',
  FETCH_USERS_WITH_INVOICES_FAILURE = 'FETCH_USERS_WITH_INVOICES_FAILURE',
  FETCH_USER_INVOICES_START = 'FETCH_USER_INVOICES_START',
  FETCH_USER_INVOICES_SUCCESS = 'FETCH_USER_INVOICES_SUCCESS',
  FETCH_USER_INVOICES_FAILURE = 'FETCH_USER_INVOICES_FAILURE',
}
